var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Tabs',{attrs:{"act":_vm.curActPage,"panes":_vm.panes},on:{"del":_vm.onTabDel,"delAll":_vm.onTabDelAll}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }